export const savedDeviceTranslations = {
  lv: {
    title: 'Saglabātās ierīces',
    subtitle: 'Pārlūki, kuros pieteikšanās kods nav jāievada 60 dienas pēc “Atcerēties šo ierīci”.',
    created: 'Saglabāta',
    validTill: 'Derīga līdz',
    lastUsed: 'Pēdējoreiz izmantota',
    browser: 'Pārlūks',
    actions: 'Darbības',
    current: 'Šī ierīce',
    forget: 'Aizmirst',
    forgetAll: 'Aizmirst visas',
    confirmOne: 'Aizmirst šo ierīci?',
    confirmAll: 'Aizmirst visas ierīces?',
    explainOne:
      'Nākamajā pieteikšanās reizē šajā pārlūkā būs jāievada kods. Pašreizējā sesija paliks atvērta.',
    explainAll:
      'Nākamajā pieteikšanās reizē katrā pārlūkā būs jāievada kods. Pašreizējā sesija paliks atvērta.',
    forgotten: 'Ierīce aizmirsta',
    allForgotten: 'Visas ierīces aizmirstas',
    failed: 'Neizdevās aizmirst ierīci. Mēģiniet vēlreiz.',
    empty: 'Nav saglabātu ierīču.',
    total: 'Kopā {{count}}',
  },
  en: {
    title: 'Saved devices',
    subtitle: 'Browsers that skip the login code for 60 days after “Remember this device”.',
    created: 'Saved',
    validTill: 'Valid until',
    lastUsed: 'Last used',
    browser: 'Browser',
    actions: 'Actions',
    current: 'This device',
    forget: 'Forget',
    forgetAll: 'Forget all',
    confirmOne: 'Forget this device?',
    confirmAll: 'Forget all devices?',
    explainOne:
      'The next login in this browser will require a code. Your current session will stay open.',
    explainAll:
      'The next login in every browser will require a code. Your current session will stay open.',
    forgotten: 'Device forgotten',
    allForgotten: 'All devices forgotten',
    failed: 'Could not forget the device. Try again.',
    empty: 'No saved devices.',
    total: 'Total {{count}}',
  },
}
